import { render } from "./UsageMeter.vue?vue&type=template&id=84bc77ce&scoped=true"
import script from "./UsageMeter.vue?vue&type=script&lang=js"
export * from "./UsageMeter.vue?vue&type=script&lang=js"

import "./UsageMeter.vue?vue&type=style&index=0&id=84bc77ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84bc77ce"]])

export default __exports__